<template>
  <a-layout-sider class="sider" width="273">
    <setting-item :title="$t('setting.navbarColor')">
      <img-checkbox-group @change="setTheme">
        <img-checkbox img="static/img/side-bar-violet.png" :checked="!dark"
                      value="violet"/>   
        <img-checkbox img="static/img/side-bar-dark.svg" :checked="dark"
                      value="dark"/>
        <img-checkbox img="static/img/side-bar-light.svg" :checked="dark"
                      value="light"/>      
                            
      </img-checkbox-group>
    </setting-item>
    <setting-item :title="$t('setting.themeColor')">
      <color-checkbox-group @change="onColorChange" :defaultValues="defaultValues" :multiple="false">
        <template v-for="(color, index) in colorList">
          <color-checkbox :color="color" :value="index + 1" :key="index"/>
        </template>
      </color-checkbox-group>
    </setting-item>
    <a-divider/>
    <setting-item :title="$t('setting.navbarPosition')">
      <img-checkbox-group @change="setLayout">
        <img-checkbox img="static/img/side-bar-left.svg" :checked="side" value="side"/>
        <img-checkbox img="static/img/side-bar-top.svg" :checked="!side" value="head"/>
      </img-checkbox-group>
    </setting-item>
    <setting-item>
      <a-list :split="false">
        <a-list-item>
          {{ $t('setting.fixedTopRail') }}
          <a-switch :checked="fixedHeader" slot="actions" size="small" @change="fixHeader"/>
        </a-list-item>
        <a-list-item>
          {{ $t('setting.fixedSidebar') }}
          <a-switch :checked="fixedSiderbar" slot="actions" size="small" @change="fixSiderbar"/>
        </a-list-item>
        <a-list-item>
          {{ $t('setting.multiTabMode') }}
          <a-switch :checked="multipage" slot="actions" size="small" @change="setMultipage"/>
        </a-list-item>
        
      </a-list>
    </setting-item>
    <setting-item :title="$t('setting.currency')">
      <a-auto-complete
        :value="currency"
        :dataSource="currencyOptions"
        :filterOption="false"
        style="width: 100%"
        :placeholder="$t('setting.currencyPlaceholder')"
        @change="onCurrencyChange"
        @select="onCurrencyChange"/>
    </setting-item>
    <a-button style="width: 100%" icon="save" @click="updateUserConfig">{{ $t('common.saveSetting') }}</a-button>
  </a-layout-sider>
</template>

<script>
import SettingItem from './SettingItem'
import StyleItem from './StyleItem'
import ColorCheckbox from '../checkbox/ColorCheckbox'
import ImgCheckbox from '../checkbox/ImgCheckbox'
import { updateTheme } from 'utils/color'
import {mapState, mapMutations} from 'vuex'
import setting from '../../store/modules/setting'

const ColorCheckboxGroup = ColorCheckbox.Group
const ImgCheckboxGroup = ImgCheckbox.Group

export default {
  name: 'Setting',
  components: {ImgCheckboxGroup, ImgCheckbox, ColorCheckboxGroup, ColorCheckbox, StyleItem, SettingItem},
  data () {
    return {
      // 既可下拉选择，也可直接输入任意符号或货币代码（如 ¥ / USD / SAR）
      // value 为实际存储并展示到 sys_user_config.CURRENCY 的文本，text 为下拉里的说明
      currencyOptions: [
        {value: '¥', text: '¥ 人民币 (CNY)'},
        {value: 'RMB', text: 'RMB 人民币'},
        {value: '$', text: '$ 美元 (USD)'},
        {value: 'USD', text: 'USD 美元'},
        {value: '€', text: '€ 欧元 (EUR)'},
        {value: 'EUR', text: 'EUR 欧元'},
        {value: '£', text: '£ 英镑 (GBP)'},
        {value: 'GBP', text: 'GBP 英镑'},
        {value: 'SAR', text: 'SAR 沙特里亚尔'},
        {value: 'AED', text: 'AED 阿联酋迪拉姆'},
        {value: '฿', text: '฿ 泰铢 (THB)'},
        {value: 'THB', text: 'THB 泰铢'},
        {value: '₫', text: '₫ 越南盾 (VND)'},
        {value: 'VND', text: 'VND 越南盾'},
        {value: 'RM', text: 'RM 马来西亚林吉特 (MYR)'},
        {value: 'MYR', text: 'MYR 林吉特'},
        {value: '₱', text: '₱ 菲律宾比索 (PHP)'},
        {value: 'PHP', text: 'PHP 菲律宾比索'},
        {value: 'Rp', text: 'Rp 印尼卢比 (IDR)'},
        {value: 'IDR', text: 'IDR 印尼卢比'},
        {value: '₹', text: '₹ 印度卢比 (INR)'},
        {value: 'INR', text: 'INR 印度卢比'},
        {value: '₺', text: '₺ 土耳其里拉 (TRY)'},
        {value: 'TRY', text: 'TRY 土耳其里拉'},
        {value: 'JPY', text: 'JPY 日元'},
        {value: '₩', text: '₩ 韩元 (KRW)'},
        {value: 'KRW', text: 'KRW 韩元'}
      ]
    }
  },
  computed: {
    ...mapState({
      multipage: state => state.setting.multipage,
      theme: state => state.setting.theme,
      colorList: state => state.setting.colorList,
      fixedSiderbar: state => state.setting.fixSiderbar,
      fixedHeader: state => state.setting.fixHeader,
      layout: state => state.setting.layout,
      color: state => state.setting.color,
      currency: state => state.setting.currency,
      user: state => state.account.user
    }),
    dark () {
      return this.theme === 'dark'
    },
    // violet(){
    //   return this.theme === 'violet'
    // },
    side () {
      return this.layout === 'side'
    },
    defaultValues () {
      let currentColor = this.$store.state.setting.color
      if (Array.isArray(currentColor)) {
        currentColor = currentColor[0]
      }
      let index = this.colorList.indexOf(currentColor) + 1
      return `[${index}]`
    }
  },
  methods: {
    ...mapMutations({setSettingBar: 'setting/setSettingBar'}),
    onColorChange (values, colors) {
      if (colors.length > 0) {
        updateTheme(colors)
        this.$store.commit('setting/setColor', colors)
      }
    },
    setTheme (values) {
      this.$store.commit('setting/setTheme', values[0])
    },
    setLayout (values) {
      this.$store.commit('setting/setLayout', values[0])
    },
    setMultipage (checked) {
      this.$store.commit('setting/setMultipage', checked)
    },
    onCurrencyChange (value) {
      this.$store.commit('setting/setCurrency', value)
    },
    fixSiderbar (checked) {
      this.$store.commit('setting/fixSiderbar', checked)
    },
    fixHeader (checked) {
      this.$store.commit('setting/fixHeader', checked)
    },
    updateUserConfig () {
      this.$put('user/userconfig', {
        multiPage: this.multipage ? '1' : '0',
        theme: this.theme,
        fixSiderbar: this.fixedSiderbar ? '1' : '0',
        fixHeader: this.fixedHeader ? '1' : '0',
        layout: this.layout,
        color: this.color[0],
        currency: this.currency,
        companyCode: this.user.companyCode,
        userId: this.user.userId
      }).then(() => {
        this.$message.success('Saved')
        this.setSettingBar(false)
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .sider {
    background-color: #fff;
    height: 100%;
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    position: relative;
    .flex {
      display: flex;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/setting/Setting.vue